<template>
  <div class="row alert-primary pt-1 pb-1 ml-0 mr-0 mb-3">
    <div class="col">
      <div class="row poster pt-1" v-if="thumbnails === true">
        <div v-bind:id="'poster' + poster.abstract_id" class="col d-flex my-auto">
          <router-link :to="'/viewer/' + poster.abstract_id">
            <img v-lazy="getImgUrl(poster.content.poster)" v-bind:alt="poster.title"
                 class="img-fluid align-middle">
          </router-link>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div>{{ _.groupCapital }}: {{ poster.grouped }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col align-middle font-weight-bold" v-html="poster.presentation_code +' ' + poster.title"></div>
      </div>
      <div class="row">
        <div class="col smaller" v-html="poster.authorline"></div>
      </div>
      <div class="row">
        <div class="col align-middle smaller overflow-hidden h-25" v-html="poster.instituteline"></div>
      </div>
      <div class="row">
        <div class="col small">
          Rating: {{ ratings[poster.id].rating }} ({{ ratings[poster.id].count }} votes)
        </div>
      </div>
      <div class="row">
        <div class="col poster-text">
        </div>
      </div>
      <UserShare :poster="poster.abstract_id" :title="poster.title" v-if="shareShow == poster.abstract_id"/>
      <div class="row mt-3 mb-3">
        <div class="col d-flex">
          <router-link class="btn btn-primary btn-sm mx-auto w-100" :to="'/viewer/' + poster.abstract_id">
            <icon :icon="['fad', 'eye']"/>
            <br>
            View
          </router-link>
        </div>
        <div class="col d-flex" v-if="poster.content.audio != null">
          <router-link class="btn btn-primary btn-sm mx-auto w-100" :to="'/viewer/' + poster.abstract_id">
            <icon :icon="['fad', 'volume']"/>
            <br>
            Audio
          </router-link>
        </div>
        <div class="col d-flex" v-if="poster.content.video != null">
          <router-link class="btn btn-primary btn-sm mx-auto w-100" :to="'/viewer/video/' + poster.abstract_id"
          >
            <icon :icon="['fad', 'video']"/>
            <br>
            Video
          </router-link>
        </div>
        <!--div class="col d-flex">
          <button class="btn btn-primary btn-sm mx-auto" v-on:click="toggleShare(poster.abstract_id)">
            <icon :icon="['fad', 'share']"/>
            <br>
            Share
          </button>
        </div-->
        <div class="col d-flex">
          <router-link class="btn btn-primary btn-sm mx-auto w-100" :to="'/mail/' + poster.abstract_id">
            <icon :icon="['fad', 'envelope']"/>
            <br>
            Contact
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Rating from "../Rating"
import UserShare from "../UserShare"
import {mapState} from 'vuex'

export default {
  name: 'Wall',
  components: {Rating, UserShare},
  props: {
    poster: {},
    shareShow: {},
  },
  computed: {
    ...mapState(
        ['ratings', "thumbnails"]
    ),
  },
  methods: {
    getImgUrl(src) {
      return process.env.VUE_APP_PATH_FILESERVERURL + src + '/resize/' + process.env.VUE_APP_THUMBNAIL_WIDTH + '/' + process.env.VUE_APP_THUMBNAIL_HEIGHT;
      // return process.env.VUE_APP_PATH_S3URL + src + '-' + process.env.VUE_APP_THUMBNAIL_WIDTH + '-' + process.env.VUE_APP_THUMBNAIL_HEIGHT + '-1-undefined-image';
    },
    toggleShare: function (poster) {
      if (this.shareShow != poster) {
        this.shareShow = poster;
      } else {
        this.shareShow = null;
      }
    },
  },
}
</script>
<style scoped>
.poster {
  /*border-bottom: solid 2px #7e7e7e;*/
}

.poster-text {
}

</style>
